import Button from "../../Components/Button/Button";
import { dateAndTimeConverter } from "../../Utils/constants";

export default function Success(props) {
  return (
    <div
      style={{ height: "calc(100% - 64px)" }}
      className="inherit-parent-width padding-large display-flex flex-direction-column flex-justify-content-space-between"
    >
      <div />
      <div className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center">
        <div className="wrapper padding-bottom-larger">
          <svg
            style={{
              stroke: props.isOfflineProcedure ? "orange" : ""
            }}
            className="check_mark"
            viewBox="0 0 52 52"
          >
            <circle
              style={{
                stroke: props.isOfflineProcedure ? "orange" : ""
              }}
              className="check_mark_circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="check_mark_check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <div className="font-size-medium  text-align-center ">
          PROCEDURE COMPLETED!
        </div>
        <div className="font-size-small text-align-center padding-top-large font-color-tertiaryColor5">
          PROCEDURE FOR THIS INTERVAL IS COMPLETED SUCCESSFULLY
        </div>

        <div className="padding-top-larger text-align-center font-size-small">
          <Fields
            title="EMPLOYEE"
            data={
              `${props.employee?.name} , ${props?.employee?.phoneNumber}` ||
              "N/A"
            }
          />

          <Fields
            title="TIME"
            data={`${dateAndTimeConverter(+new Date(), "secondDate")},
          ${dateAndTimeConverter(+new Date(), "Time")}`}
          />

          <Fields
            title="PROCEDURE ACTIVATES ON"
            data={`${dateAndTimeConverter(
              props.procedureStatus?.timestamp,
              "Time"
            )} ,${dateAndTimeConverter(
              props.procedureStatus?.timestamp,
              "cardDate"
            )}`}
          />

          <Fields
            title="LOCATIONS"
            data={`${props.location?.PCTNo} - ${props.location?.location}`}
          />

          {props.isOfflineProcedure && (
            <Fields
              title="STATUS"
              data={
                "Procedure is completed in offline, will be synced once online"
              }
            />
          )}
        </div>
      </div>

      <Button
        data-cy="okay-button"
        type="button"
        text="Okay"
        boxShadow={false}
        onClick={() => {
          props.navigate(`${props.location?.documentId}/procedures`);
        }}
      />
    </div>
  );
}

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-large">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "180px", textAlign: "left" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${
          !props.removeCapitalize && "text-capitalize"
        }`}
        data-cy={props.dataCy || props.data}
        style={{
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};
